<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <UserExtraConfig slot-scope="{data}"></UserExtraConfig>
  </l-cache>
</template>
<script>
  import UserExtraConfig from './userExtraConfig'
  export default {
    name: 'userExtraConfigBox',
    components: {UserExtraConfig},
    methods: {
      async getItem (key) {
        return {}
      }
    }
  }
</script>

